import { API } from 'src/config';
import { doGet }  from './FetchWrapper';

export const search = str => {
    return doGet(`/api/public/listCities?str=${str}`)
};
